// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#configurator-group-lite[data-v-50934ca4] {\n    display: inline-flex;\n    height: calc(100% - 82px);\n    box-sizing: border-box;\n}\n\n", ""]);
// Exports
module.exports = exports;
